module.exports = __webpack_public_path__ + "static/19-011e09cc22e9b1e18e6b15a81f042525.jpeg";